import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Shop = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section */}
      <section
        className="relative h-96 flex items-center justify-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1556821840-3a63f95609a7)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">{t('officialShop')}</h1>
          <p className="text-xl md:text-2xl font-light">{t('premiumMerchandise')}</p>
        </div>
      </section>

      {/* Coming Soon Section with Fog Effect */}
      <section className="relative py-32 bg-zinc-950 overflow-hidden">
        {/* Fog/Blur Overlay */}
        <div className="absolute inset-0 backdrop-blur-sm bg-black/60"></div>
        
        {/* Animated Fog Effect */}
        <div 
          className="absolute inset-0 opacity-30"
          style={{
            background: 'radial-gradient(ellipse at 20% 50%, rgba(6, 182, 212, 0.2) 0%, transparent 50%), radial-gradient(ellipse at 80% 50%, rgba(236, 72, 153, 0.2) 0%, transparent 50%)',
            animation: 'pulse 4s ease-in-out infinite'
          }}
        ></div>
        
        {/* Content */}
        <div className="relative z-10 container mx-auto px-4 text-center">
          <div className="max-w-2xl mx-auto">
            <ShoppingCart className="w-20 h-20 text-cyan-400 mx-auto mb-8 opacity-50" />
            <h2 className="text-5xl md:text-7xl font-black text-white mb-6">
              {t('availableSoon').split(' ')[0]} <span className="text-cyan-400">{t('availableSoon').split(' ').slice(1).join(' ')}</span>
            </h2>
            <p className="text-xl text-zinc-400 mb-8">
              {t('shopComingSoonDesc')}
            </p>
            <div className="inline-block border-2 border-cyan-400/30 px-8 py-4">
              <p className="text-zinc-500 text-sm tracking-wider uppercase">{t('stayTuned')}</p>
            </div>
          </div>
        </div>
        
        {/* Bottom Fog */}
        <div 
          className="absolute bottom-0 left-0 right-0 h-32"
          style={{
            background: 'linear-gradient(to top, rgba(0,0,0,1) 0%, transparent 100%)'
          }}
        ></div>
      </section>
    </div>
  );
};

export default Shop;
